import { render, staticRenderFns } from "./AppMenuItemReport.vue?vue&type=template&id=9f7c9540&scoped=true"
import script from "./AppMenuItemReport.vue?vue&type=script&lang=ts"
export * from "./AppMenuItemReport.vue?vue&type=script&lang=ts"
import style0 from "./AppMenuItemReport.vue?vue&type=style&index=0&id=9f7c9540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7c9540",
  null
  
)

export default component.exports